/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DirectoryRoleMapping,
  DirectoryRoleMapping$inboundSchema,
} from "./directoryrolemapping.js";
import {
  DirectoryRoleSetupSideEffect,
  DirectoryRoleSetupSideEffect$inboundSchema,
} from "./directoryrolesetupsideeffect.js";
import { Role, Role$inboundSchema } from "./role.js";

export type ApplyDirectoryRoleSetupResult = {
  /**
   * Roles this request created.
   */
  createdRoles: Array<Role>;
  /**
   * The resulting mappings of every source in the request.
   */
  mappings: Array<DirectoryRoleMapping>;
  /**
   * Work requested after commit.
   */
  sideEffects: Array<DirectoryRoleSetupSideEffect>;
};

/** @internal */
export const ApplyDirectoryRoleSetupResult$inboundSchema: z.ZodMiniType<
  ApplyDirectoryRoleSetupResult,
  unknown
> = z.pipe(
  z.object({
    created_roles: z.array(Role$inboundSchema),
    mappings: z.array(DirectoryRoleMapping$inboundSchema),
    side_effects: z.array(DirectoryRoleSetupSideEffect$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_roles": "createdRoles",
      "side_effects": "sideEffects",
    });
  }),
);

export function applyDirectoryRoleSetupResultFromJSON(
  jsonString: string,
): SafeParseResult<ApplyDirectoryRoleSetupResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ApplyDirectoryRoleSetupResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ApplyDirectoryRoleSetupResult' from JSON`,
  );
}
